'use client';

import React from 'react';

export default function ErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-slate-900 rounded-2xl shadow-md border border-slate-200 dark:border-slate-800 p-6 text-center space-y-4">
        <div className="w-12 h-12 rounded-full bg-rose-100 dark:bg-rose-950 text-rose-600 dark:text-rose-400 flex items-center justify-center mx-auto text-xl font-bold">
          !
        </div>
        <h2 className="text-xl font-bold text-slate-900 dark:text-slate-100">Đã xảy ra lỗi</h2>
        <p className="text-sm text-slate-600 dark:text-slate-400">
          {error?.message || 'Không thể hiển thị nội dung này. Vui lòng thử lại.'}
        </p>
        {error?.digest && (
          <p className="text-xs font-mono text-slate-400">Mã lỗi: {error.digest}</p>
        )}
        <div className="flex gap-2 justify-center pt-2">
          <button
            onClick={() => reset()}
            className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition"
          >
            Thử lại
          </button>
          <button
            onClick={() => { window.location.href = '/'; }}
            className="px-4 py-2 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-semibold rounded-xl hover:bg-slate-200 transition"
          >
            Về trang chủ
          </button>
        </div>
      </div>
    </div>
  );
}
